"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBetweenByTime = exports.isAfterByTime = exports.isBeforeByTime = exports.latestTimeDate = exports.earliestTimeDate = void 0;
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
/**
 * 最も早い時間のDateを返す
 * @param date
 * @returns
 */
const earliestTimeDate = (dates) => {
    return (0, lodash_1.minBy)(dates, (d) => hoursFromStartOfDay(d));
};
exports.earliestTimeDate = earliestTimeDate;
/**
 * 最も遅い時間のDateを返す
 * @param date
 * @returns
 */
const latestTimeDate = (dates) => {
    return (0, lodash_1.maxBy)(dates, (d) => hoursFromStartOfDay(d));
};
exports.latestTimeDate = latestTimeDate;
const isBeforeByTime = (a, b, allowEqual = false) => {
    if (allowEqual) {
        return hoursFromStartOfDay(a) <= hoursFromStartOfDay(b);
    }
    return hoursFromStartOfDay(a) < hoursFromStartOfDay(b);
};
exports.isBeforeByTime = isBeforeByTime;
const isAfterByTime = (a, b, allowEqual = false) => {
    if (allowEqual) {
        return hoursFromStartOfDay(a) >= hoursFromStartOfDay(b);
    }
    return hoursFromStartOfDay(a) > hoursFromStartOfDay(b);
};
exports.isAfterByTime = isAfterByTime;
const isBetweenByTime = (date, start, end, allowEqual = false) => {
    return ((0, exports.isAfterByTime)(date, start, allowEqual) &&
        (0, exports.isBeforeByTime)(date, end, allowEqual));
};
exports.isBetweenByTime = isBetweenByTime;
/**
 * startOfDayから何時間経過しているか。
 * 複数のDateのうちどのDateが最も早い/遅い時間帯なのか比較するのに使用
 */
const hoursFromStartOfDay = (date) => {
    return (0, date_fns_1.getHours)(date) + (0, date_fns_1.getMinutes)(date) / 60;
};
//# sourceMappingURL=compareDateByTime.js.map